export enum EPublicRoutes {
  AUTENTICACION = '/autenticacion/ingreso',
}

export enum EProhibidoRoutes {
  PROHIBIDO = '/prohibido',
}

export enum EMantenimientoRoutes {
  MANTENIMIENTO = '/mantenimiento',
}
